module.exports = __webpack_public_path__ + "img/pijltje-links-wit.1be1dfd5c008a9c60cdd5efc309beea6.svg";